export const affiliateAPI = {
    getEnabledBrands: '/affiliates/enabled-brands',
    getBrandSubscription: '/affiliates/brands',
    getPlayerCountry: '/affiliates/player-countries',
    getAllCountries: '/affiliates/market-countries',

    getCasinosWithDaySales: '/affiliates/casinos-day-sales',
    getAffiliateSummaryReports: '/affiliates/summary-reports-data',

    getAffiliateDashboardReports: '/affiliates/affiliate-dashboard',

    exportAffiliateSummaryReports: '/affiliates/summary-reports-data/export',
    exportMediaTrafficReports: '/affiliates/media-traffic-data/export',

    getDefaultLanguage: '/affiliates/pre-login/language-from-header',
    getAllCountriesPreLogin: '/affiliates/pre-login/market-countries',

    getAffiliateSubscription: '/affiliates/subscriptions',
    getAffiliateBetaFeatures: '/affiliates/beta-features',

    getAffiliateCasinoReports: '/affiliates/get-casino-reports',
    getRewardPlans: '/affiliates/reward-plans',

    getPostbackSettings: '/affiliates/postback-settings',
    updatePostbackSettings: '/affiliates/postback-settings',

    getTurnstileConfig: '/affiliates/pre-login/turnstile-config',

    getAffiliateFinancialReports: '/affiliates/financial-reports',
    exportAffiliateFinancialReports: '/affiliates/financial-reports/export',

    getAffiliateSalesTotals: '/affiliates/affiliate-sales-totals'
};
